import {Languages} from "../components/common/Texts";
import jacquesLinesEs from '../images/charts/jacques-lines-es.png';
import jacquesNoLinesEs from '../images/charts/jacques-no-lines-es.png';
import jacquesLinesPt from '../images/charts/jacques-lines-pt.png';
import jacquesNoLinesPt from '../images/charts/jacques-no-lines-pt.png';
import jacquesLinesEn from '../images/charts/jacques-lines-en.png';
import jacquesNoLinesEn from '../images/charts/jacques-no-lines-en.png';
import terniumLinesEs from '../images/charts/ternium/jacques-lines-es.png';
import terniumNoLinesEs from '../images/charts/ternium/jacques-no-lines-es.png';
import terniumLinesPt from '../images/charts/ternium/jacques-lines-pt.png';
import terniumNoLinesPt from '../images/charts/ternium/jacques-no-lines-pt.png';
import terniumLinesEn from '../images/charts/ternium/jacques-lines-en.png';
import terniumNoLinesEn from '../images/charts/ternium/jacques-no-lines-en.png';
import marvalLinesEs from '../images/charts/marval/jacques-lines-es.png';
import marvalNoLinesEs from '../images/charts/marval/jacques-no-lines-es.png';
import marvalLinesPt from '../images/charts/marval/jacques-lines-pt.png';
import marvalNoLinesPt from '../images/charts/marval/jacques-no-lines-pt.png';
import marvalLinesEn from '../images/charts/marval/jacques-lines-en.png';
import marvalNoLinesEn from '../images/charts/marval/jacques-no-lines-en.png';

const JACQUES_CHARTS = {
    all: {
        [Languages.es]: {
            lines: jacquesLinesEs,
            no_lines: jacquesNoLinesEs
        },
        [Languages.pt]: {
            lines: jacquesLinesPt,
            no_lines: jacquesNoLinesPt
        },
        [Languages.en]: {
            lines: jacquesLinesEn,
            no_lines: jacquesNoLinesEn
        }
    },
    'ternium': {
        [Languages.es]: {
            lines: terniumLinesEs,
            no_lines: terniumNoLinesEs
        },
        [Languages.pt]: {
            lines: terniumLinesPt,
            no_lines: terniumNoLinesPt
        },
        [Languages.en]: {
            lines: terniumLinesEn,
            no_lines: terniumNoLinesEn
        }
    },
    'marval': {
        [Languages.es]: {
            lines: marvalLinesEs,
            no_lines: marvalNoLinesEs
        },
        [Languages.pt]: {
            lines: marvalLinesPt,
            no_lines: marvalNoLinesPt
        },
        [Languages.en]: {
            lines: marvalLinesEn,
            no_lines: marvalNoLinesEn
        }
    }
}

export function getChart(language, company, withLines) {
    const lines = withLines ? 'lines' : 'no_lines';
    const lang = (language === null || language === undefined) ? Languages.es : language;
    const comp = (company === null || company === undefined || !(company in JACQUES_CHARTS)) ?
        'all' : company;

    return JACQUES_CHARTS[comp][lang][lines];
}


